// extracted by mini-css-extract-plugin
var _1 = "L2c8boRs3oHFRd1Zxinj";
export { _1 as "root" }
